import React from 'react';
import ModalSkeleton from '../ModalSkeleton';
import classes from './EventsMoreFiltersModal.module.css';
import { Col, Row } from 'react-bootstrap';
import Button from '../../Component/Button/Button';

const EventsMoreFiltersModal = ({ show, setShow, children, t, onApply }) => {
  return (
    <ModalSkeleton
      header={t('filters.filters')}
      headerClass={classes.headerClass_headerClass}
      width={'600px'}
      show={show}
      setShow={setShow}
      modalClass={classes.modal}>
      <Row className={classes.row}>
        {children}
        <Col md={12}>
          <Button
            className={classes.btn}
            onClick={() => {
              onApply?.();
              setShow(false);
            }}>
            {t('filters.applyBtn')}
          </Button>
        </Col>
      </Row>
    </ModalSkeleton>
  );
};

export default EventsMoreFiltersModal;
